<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="1000px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="content">
      <el-form ref="addForm" :model="addForm" :rules="dynamicRules" label-width="110px" v-loading="loading">
        <div class="section-header">SKU查询</div>
        <div class="sku-query">
          <el-form-item label="SKU编码" prop="skuCode">
            <el-input v-model="addForm.skuCode" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="SKU名称" prop="skuName">
            <el-input v-model.trim="addForm.skuName" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
          <div class="sku-query-btn">
            <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
            <el-button type="warning" size="mini" @click="onReset">重置</el-button>
          </div>
        </div>
        <!-- SPU设置部分 -->
        <div class="section-header">SPU设置</div>
        <div class="spu-info">
          <div class="info-item">
            <span class="label">SPU编码：</span>
            <span class="value orange-text code-ellipsis">{{ addForm.spuCode }}</span>
          </div>
          <div class="info-item">
            <span class="label">SPU名称：</span>
            <span class="value orange-text text-ellipsis">{{ addForm.spuName }}</span>
          </div>
        </div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model.trim="addForm.productName" size="mini" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 商品信息部分 -->
        <div v-for="(product, index) in addForm.itemAOS" :key="index">
          <div class="section-header">商品{{ index + 1 }}</div>
          <div class="product-header">
            <div class="product-info">
              <div class="info-item">
                <span class="label">商品编码：</span>
                <el-tooltip :content="product.skuCode" placement="top" :disabled="!product.skuCode">
                  <span class="value orange-text code-ellipsis">{{ product.skuCode }}</span>
                </el-tooltip>
              </div>
              <div class="info-item">
                <span class="label">商品名称：</span>
                <el-tooltip :content="product.goodsName" placement="top" :disabled="!product.goodsName">
                  <span class="value orange-text text-ellipsis">{{ product.goodsName }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="SKU推广名称" class="required-label" label-width="110px" :prop="'itemAOS.' + index + '.skuName'">
                <el-input v-model.trim="product.skuName" size="mini" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'BasicInfoEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 编辑的行数据
    rowData: {
      type: Object,
      default: () => ({}),
    },
    listNo: [Number, String],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '产品文案编辑';
    },
    // 动态生成校验规则
    dynamicRules() {
      const rules = {
        // category: [{ required: false, message: '请输入可放类目', trigger: 'blur' }],
      };
      if (this.addForm.itemAOS && this.addForm.itemAOS.length) {
        this.addForm.itemAOS.forEach((_, index) => {
          rules[`itemAOS.${index}.skuName`] = [{ required: true, message: '请选择SKU推广名称', trigger: 'change' }];
        });
      }
      return rules;
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        productName: '',
        shelfType: 1,
        stores: [],
        itemAOS: [],
      },
      rules: {
        // productName: [{ required: false, message: '请输入可放类目', trigger: 'blur' }],
        // shelfType: [{ required: true, message: '请选择上架类型', trigger: 'change' }],
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  mounted() {
    this.$set(this.addForm, 'skuCode', this.rowData.skuCode);
    this.$set(this.addForm, 'skuName', this.rowData.goodsName);
    this.initFormData();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      // this.$refs.addForm.validate((valid) => {
        // if (!valid) return;
        this.loadingBth = true;
        const saveData = {
          listNo: this.listNo,
          ...this.addForm
        };

        this.$q.newProduct
          .productListProductEdit({ data: saveData })
          .then((res) => {
            if (res.success) {
              this.$message.success(`保存成功`);
              this.isVisible = false;
              this.$emit('success');
            } else {
              this.$notify.error({
                message: res.message || '保存失败',
                duration: 0
              });
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
    },

    onSearch() {
      this.initFormData();
    },
    onReset() {
      this.addForm.skuCode = '';
      this.addForm.skuName = '';
      this.initFormData();
    },

    // 初始化表单数据
    initFormData() {
      this.loading = true;
      let data = {
        listNo: this.listNo,
        spuCode: this.rowData.spuCode,
        skuCode: this.addForm.skuCode,
        skuName: this.addForm.skuName,
      };
      this.$q.newProduct
        .productListGetDetail({ data: data })
        .then((res) => {
          this.addForm = {
            ...res.data,
            skuCode: this.addForm.skuCode,
            skuName: this.addForm.skuName,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--mini .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner {
  width: 200px !important;
}

>>> .el-input {
  width: 200px !important;
}

>>> .el-textarea {
  width: 100% !important;
}

.content {
  padding-right: 15px;
  max-height: 70vh;
  overflow-y: auto;
}

.section-header {
  font-weight: bold;
  border-bottom: 1px solid #DCDFE6;
  padding: 5px 0 15px 0;
  font-size: 16px;
  margin: 15px 0;
}

.spu-info, .product-header .product-info {
  display: flex;
  margin-bottom: 15px;

  .info-item {
    margin-right: 30px;

    .label {
      font-weight: bold;
      margin-right: 5px;
    }

    .orange-text {
      color: #FF8C00;
    }
  }
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .batch-copy {
    .copy-btn {
      margin-left: 10px;
    }
  }
}

.sku-query {
  display: flex;
  justify-content: space-between;
}

.sku-query-btn {
  margin-top: 10px;
}


.required-label {
  >>> .el-form-item__label:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}

>>> .dialog-content {
  padding-right: 0 !important;
  padding-left: 15px !important;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
.code-ellipsis {
  display: inline-block
  width: 300px
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.text-ellipsis {
  max-width: 400px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
